import { createAction } from '@reduxjs/toolkit';

export const setIsAiWriterTourFinished = createAction<boolean>(
  'aiWriter/setIsAiWriterTourFinished'
);

// #tech-debt https://app.clickup.com/t/862jjp0bb
export const setIsUserOnboarded = createAction<boolean>('aiWriter/setIsUserOnboarded');
